import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export type TrackingFrom = {
  event_from: string;
  event_detail_from: string;
  stage_from: string;
};

export const useTrackingLocation = () => {
  const location = useLocation();
  return location.state as TrackingFrom | undefined;
};
